import React from 'react';

export class ErrorBoundary extends React.Component {
  state = { hasError: false };

  static getDerivedStateFromError() { return { hasError: true }; }

  componentDidCatch(error, info) {
    if (process.env.NODE_ENV === 'development') {
      console.error('Error:', error.message, info.componentStack);
    }
  }

  render() {
    if (this.state.hasError) {
      return (
        <div role="alert" style={{ padding:'48px 24px', textAlign:'center', fontFamily:'Jost,sans-serif' }}>
          <div style={{ fontSize:'32px', marginBottom:'16px' }}>🌿</div>
          <h2 style={{ fontFamily:'Cormorant Garamond,serif', fontSize:'28px', fontWeight:300, marginBottom:'10px' }}>
            Something went wrong
          </h2>
          <p style={{ fontSize:'14px', color:'#5A6E5C', marginBottom:'24px' }}>
            Please refresh the page. If it keeps happening, contact us directly.
          </p>
          <button
            onClick={() => window.location.reload()}
            style={{ padding:'10px 28px', background:'#243C28', color:'#fff', border:'none', borderRadius:'6px', cursor:'pointer', fontSize:'13px' }}
          >
            Refresh page
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
